import { render, staticRenderFns } from "./ButtonAppleAuth.vue?vue&type=template&id=7977d43f&scoped=true"
import script from "./ButtonAppleAuth.vue?vue&type=script&lang=js"
export * from "./ButtonAppleAuth.vue?vue&type=script&lang=js"
import style0 from "./ButtonAppleAuth.vue?vue&type=style&index=0&id=7977d43f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977d43f",
  null
  
)

export default component.exports